import { render, staticRenderFns } from "./MassiveAlerts.vue?vue&type=template&id=1c7300a5&"
import script from "./MassiveAlerts.vue?vue&type=script&lang=js&"
export * from "./MassiveAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports